module.exports = __webpack_public_path__ + "img/location.70b78045.svg";